import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { first, take } from 'rxjs/operators';
import { UniversalDialogComponent } from '../components/universal-dialog/universal-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from '../models/dialog/dialog-data.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  

  constructor(private http: HttpClient, public dialog: MatDialog) {}

  public licznik = 0;
  /**
   * Checks in every set frequency the version of frontend application
   * @param url
   * @param {number} frequency - in milliseconds, defaults to 30 minutes
   */
  public initVersionCheck(url, frequency = 1000 * 60 * 15) {
    setInterval(() => {
      this.checkVersion(url);
    }, frequency);
  }

  /**
   * Will do the call and check if the hash has changed or not
   * @param url
   */
  private checkVersion(url) {
    // timestamp these requests to invalidate caches
    this.http
      .get(url + '?t=' + new Date().getTime())
      .pipe(first())
      .subscribe(
        (response: any) => {
          const version = response.version;
          const environment_version = environment.Version;
          const hashChanged = environment_version != version;
          // If new version, do something
          if (hashChanged) {
            this.licznik++;
            if(this.licznik > 2){
              // window.location.reload();
              location.reload(true);
            } else if(this.licznik > 1){
              let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
              const data: DialogData = {
                title: 'nowa_wersja',
                content: 'prosimy_o_zapisanie_zmian_nastapi_automatyczne_odswiezenie',
                answerOk: true,
              };
              dialogRef = this.dialog.open(UniversalDialogComponent, { data: data });
            } else {
              let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
              const data: DialogData = {
                title: 'nowa_wersja',
                content: 'prosimy_o_zapisanie_zmian_i_odswiezenie_strony',
                answerOk: true,
              };
              dialogRef = this.dialog.open(UniversalDialogComponent, { data: data });
            }
            
          }
          
        },
        (err) => {
          console.error(err, 'Could not get version');
        }
      );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   * @param currentHash
   * @param newHash
   * @returns {boolean}
   */
  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }
}
